import { render, staticRenderFns } from "./ApproveDescription.vue?vue&type=template&id=abb9ad68"
import script from "./ApproveDescription.vue?vue&type=script&lang=js"
export * from "./ApproveDescription.vue?vue&type=script&lang=js"
import style0 from "./ApproveDescription.vue?vue&type=style&index=0&id=abb9ad68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports